import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { IconCore } from '../Icon.Core/Icon.Core.es.js';

const sizes = {
    /**
     * Large Size.
     */ lg: {
        container: 58,
        icon: 28
    },
    /**
     * Medium Size.
     */ md: {
        container: 48,
        icon: 24
    },
    /**
     * Small Size.
     */ sm: {
        container: 32,
        icon: 16
    },
    /**
     * Extra Small Size.
     */ xs: {
        container: 24,
        icon: 12
    },
    /**
     * Extra Extra Small Size.
     */ xxs: {
        container: 20,
        icon: 12
    }
};
const IconCircle = ({ className, size = 'md', intent = 'default', name, ...iconProps })=>{
    const iconName = name.toLowerCase();
    const classes = classNames('cb-icon-circle', intent, className);
    return jsx("div", {
        className: classes,
        "data-testid": `icon-circle-${iconName}`,
        style: {
            width: sizes[size].container,
            height: sizes[size].container
        },
        children: jsx(IconCore, {
            name: name,
            size: sizes[size].icon,
            ...iconProps
        })
    });
};
IconCircle.displayName = 'Icon.Circle';

export { IconCircle, IconCircle as default };
//# sourceMappingURL=Icon.Circle.es.js.map
